// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__4ESqr","buttons":"PendingPaymentAlert_buttons__1PyWT"};